import { getQueryStrings, setStore, getStore, removeStore } from './util'
import axios from 'axios'

import $server from './server.js'
import $config from './config.js'

const STORE_TOKEN_KEY = '__token_info' // 授权登陆缓存标识
let STORE_TOKEN = null // 内存中存token

// 获取过期时间，默认到明天0点
function getExpiredTime() {
  const endTime = new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000
  const currentTime = Date.now()
  const TOW_HOURS_TIME = 2 * 60 * 60 * 1000
  const expiredTime = endTime - currentTime

  return expiredTime < TOW_HOURS_TIME ? currentTime + TOW_HOURS_TIME : endTime
}

// 页面初始化时获取token，并设置token到缓存中
export const getAndSetTokenInfo = async () => {
  // 若有token，则视为授权登录方式
  const urlParams = getQueryStrings()
  const { authVersion, authToken, appId } = (await getTokenFromKey(urlParams.authKey)) || urlParams

  // 若地址栏无token 且 local中没有token字段则视为正常登录方式
  // 若地址栏无token，则返回当前local里面的token信息
  // eslint-disable-next-line no-return-assign
  if (!(authVersion && authToken && appId)) {
    STORE_TOKEN = getStore(STORE_TOKEN_KEY)
  } else {
    STORE_TOKEN = {
      AuthorizerToken: authToken,
      AuthorizationVersion: authVersion,
      AppId: appId,
    }
    setStore(STORE_TOKEN_KEY, STORE_TOKEN, getExpiredTime())
  }

  return STORE_TOKEN
}

// 获取local中的token
export const getTokenInfo = () => {
  return STORE_TOKEN || getStore(STORE_TOKEN_KEY)
}

// 删除local中的token
export const removeTokenInfo = () => {
  STORE_TOKEN = null
  removeStore(STORE_TOKEN_KEY)
}

// 获取带token的参数信息
export const getTokenParams = async () => {
  const tokenInfo = getTokenInfo()
  if (!tokenInfo) return ''
  const key = await getKeyFromToken(tokenInfo)

  return key ? `authKey=${key}` : ''
}

// 从参数Key中解析出Token
export const getTokenFromKey = async authKey => {
  if (!authKey) return null
  try {
    const { data } = await $server($config.getTokenFromKey(), { authKey })
    console.log(data)

    return data
      ? {
          authVersion: data.version,
          authToken: data.token,
          appId: data.appId,
        }
      : null
  } catch (e) {
    console.error('getTokenFromKey---------', e)
  }
}
export const getKeyFromToken = async tokenInfo => {
  if (!tokenInfo) return null
  const { AppId: appId, AuthorizerToken: token } = tokenInfo
  const { data } = await $server($config.getKeyFromToken(), { appId, token })

  return data.authKey
}

export function getToken() {
  // ep部分场景返回loginToken
  let { token } = getQueryStrings()
  const { loginToken } = getQueryStrings()
  if ((!token || token === 'undefined') && loginToken !== 'undefined') {
    token = loginToken
  }
  if (!token) return localStorage.getItem('token')

  localStorage.setItem('token', token)

  return token
}

// 返回token登录需要携带的请求头
export function getTokenHeader() {
  const token = getToken()
  if (!token || token === 'undefined' || token === 'null') return
  axios.defaults.headers['X-Tsign-token-way'] = 'header'
  axios.defaults.headers['X-Tsign-token'] = token
}
